import { render, staticRenderFns } from "./Create-User.vue?vue&type=template&id=bf779ca4"
import script from "./Create-User.vue?vue&type=script&lang=js"
export * from "./Create-User.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports